import React, { memo, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BuildStepQuiz } from './BuildStepQuiz';
import { BuildStepSettings } from './BuildStepSettings';
interface BuildPageBodyProps {
  currentStep: 'quiz' | 'settings';
}
export const BuildPageBody = memo(({
  currentStep
}: BuildPageBodyProps) => {
  // step 전환 시 스크롤을 맨 위로. 기존 AnimatePresence onExitComplete를 대체.
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    });
  }, [currentStep]);
  const isQuizActive = currentStep === 'quiz';
  return <div className="relative overflow-hidden pb-3xl pt-[151px]  tablet-lg:pt-[88px]">
      {/*
       * Quiz step은 항상 mount된 채로 유지하고 display로만 토글한다.
       * - display:none 상태에선 IntersectionObserver / ResizeObserver / layout이 자동으로 정지
       * - useFieldArray, RHF subscription, jotai 구독, dnd-kit 등록을 전부 보존
       * - step 토글 시 N개 카드를 unmount/remount 하는 비용이 사라짐
       */}
      <BuildStepQuiz active={isQuizActive} />

      {/*
       * Settings는 트리가 작고 form에 영향이 없어 기존처럼 mount/unmount + 애니메이션을 유지한다.
       * popLayout 모드: exit 중인 요소가 position:absolute로 떠서 quiz와 layout 충돌이 없도록 한다.
       */}
      <AnimatePresence mode="popLayout">
        {currentStep === 'settings' && <motion.div key={'settings'} initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: 20
      }} transition={{
        duration: 0.2,
        ease: 'easeInOut'
      }} style={{
        position: 'relative'
      }}>
            <BuildStepSettings />
          </motion.div>}
      </AnimatePresence>
    </div>;
});